import { jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useTheme, Box, get } from "@betterment/style-closet-react";
import styled from "@emotion/styled";
import { d as disclosureInitializer } from "./disclosureInitializer-CWxY7yo2.js";
import { a as FooterText } from "./Footer-BPSPPtJk.js";
const FooterDisclosureText = styled(FooterText)`
  h2 {
    font-size: ${get("fontSizes.1")};
  }

  p,
  div,
  span {
    font-size: ${get("fontSizes.1")};
  }
`;
const FooterDisclosure = () => {
  const [disclosures, setDisclosures] = useState([]);
  const { theme } = useTheme();
  useEffect(() => {
    disclosureInitializer.subscribe((value) => {
      setDisclosures(Object.values(value).filter(Boolean));
    });
    return () => disclosureInitializer.unsubscribe();
  }, []);
  if (disclosures.length < 1) return null;
  return /* @__PURE__ */ jsx(Box, { mb: "8", children: disclosures.map((value) => /* @__PURE__ */ jsx(
    FooterDisclosureText,
    {
      as: "p",
      fontSizes: theme.fontSizes,
      dangerouslySetInnerHTML: { __html: value }
    },
    value
  )) });
};
export {
  FooterDisclosure as F
};
//# sourceMappingURL=FooterDisclosure-KpPSkL6N.js.map
